import * as R from "ramda";

import generator from "redux/hor/module";
import fetchWithView from "redux/utils/fetchWithView";

const { reducer, fetch } = generator({
  name: "normWomen",
  tableId: 128,
  parseItem: R.evolve({
    ___parent: R.propOr(null, "key"),
    custom_страна: R.propOr(null, "key"),
    custom_возрастные_группы: R.propOr(null, "label"),
    custom_группа_физической_активности: R.propOr(null, "label"),
  }),
});

export const fetchList = fetchWithView(fetch, "ts5c128cs9r422");

export { fetch };

export default reducer;
